import React, { useEffect, useState } from 'react';
import useGet from '../../Hooks/useGet.jsx';
import usePatch from '../../Hooks/usePatch.jsx';
import API_ENDPOINTS from '../../Config/api.js';
import ProfileAvatar from '../Icons/ProfileAvatar';
import useUserType from '../../Hooks/useUserType';

export default function ProfiloMSSPModal({ isOpen, onClose }) {
  const { isReseller } = useUserType();
  const { fetchedData: msspDettagli, refetch } = useGet(API_ENDPOINTS.myInfoMSSP);
  const patch = usePatch(API_ENDPOINTS.myInfoMSSP + 'update/');
  const [form, setForm] = useState({
    nome_mssp: '', email: '', piva_cf_mssp: '', telefono_mssp: '', indirizzo_mssp: '', citta_mssp: '', provincia_mssp: '', cap_mssp: '', tipo_mssp: '', stato_mssp: '', ordini_abilitati: false, percentuale_commissione: '', note_mssp: '', logo: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      // Chiudi il modal dopo salvataggio
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 500); // chiusura rapida, puoi aumentare se vuoi vedere il messaggio
    }
  }, [success, onClose]);

  useEffect(() => {
    if (msspDettagli) {
      setForm({
        nome_mssp: msspDettagli.nome_mssp || '',
        email: msspDettagli.email || '',
        piva_cf_mssp: msspDettagli.piva_cf_mssp || '',
        telefono_mssp: msspDettagli.telefono_mssp || '',
        indirizzo_mssp: msspDettagli.indirizzo_mssp || '',
        citta_mssp: msspDettagli.citta_mssp || '',
        provincia_mssp: msspDettagli.provincia_mssp || '',
        cap_mssp: msspDettagli.cap_mssp || '',
        tipo_mssp: msspDettagli.tipo_mssp || '',
        stato_mssp: msspDettagli.stato_mssp || '',
        ordini_abilitati: msspDettagli.ordini_abilitati || false,
        percentuale_commissione: msspDettagli.percentuale_commissione || '',
        note_mssp: msspDettagli.note_mssp || '',
        logo: msspDettagli.logo || null
      });
    }
  }, [msspDettagli]);

  // Reset form to original data when modal opens (discard unsaved edits)
  useEffect(() => {
    if (isOpen && msspDettagli) {
      setForm({
        nome_mssp: msspDettagli.nome_mssp || '',
        email: msspDettagli.email || '',
        piva_cf_mssp: msspDettagli.piva_cf_mssp || '',
        telefono_mssp: msspDettagli.telefono_mssp || '',
        indirizzo_mssp: msspDettagli.indirizzo_mssp || '',
        citta_mssp: msspDettagli.citta_mssp || '',
        provincia_mssp: msspDettagli.provincia_mssp || '',
        cap_mssp: msspDettagli.cap_mssp || '',
        tipo_mssp: msspDettagli.tipo_mssp || '',
        stato_mssp: msspDettagli.stato_mssp || '',
        ordini_abilitati: msspDettagli.ordini_abilitati || false,
        percentuale_commissione: msspDettagli.percentuale_commissione || '',
        note_mssp: msspDettagli.note_mssp || '',
        logo: msspDettagli.logo || null
      });
      setError('');
      setSuccess(false);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      await patch.patchData(API_ENDPOINTS.myInfoMSSP + 'update/', form);
      refetch();
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Errore nel salvataggio.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999]">
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-lg p-8 w-full max-w-3xl shadow-lg relative z-10">
          <div className="flex flex-col items-center justify-center mb-2">
            <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100 mb-2">
              <ProfileAvatar className="w-20 h-20" name={msspDettagli ? `${msspDettagli.nome_mssp}` : ''} />
            </span>
          </div>
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl">&times;</button>
          <h2 className="text-2xl font-bold mb-6 text-black text-center">{isReseller ? 'Profilo Reseller' : 'Profilo MSSP'}</h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{isReseller ? 'Nome Reseller' : 'Nome MSSP'}</label>
              <input type="text" name="nome_mssp" value={form.nome_mssp} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Partita IVA / Codice Fiscale</label>
              <input
                type="text"
                name="piva_cf_mssp"
                value={form.piva_cf_mssp}
                onChange={handleChange}
                className="w-full p-2 border rounded disabled:opacity-60"
                pattern="^([0-9]{11}|[A-Za-z0-9]{16})$"
                title="Inserire Partita IVA (11 cifre, senza prefisso IT) oppure Codice Fiscale (16 caratteri alfanumerici)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Telefono</label>
              <input
                type="text"
                name="telefono_mssp"
                value={form.telefono_mssp}
                onChange={handleChange}
                className="w-full p-2 border rounded disabled:opacity-60"
                pattern="[0-9+()\\s.\-]{6,20}"
                title="Inserire un numero di telefono valido (6-20 caratteri; consentiti +, spazi, -, ( ), .)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Indirizzo</label>
              <input type="text" name="indirizzo_mssp" value={form.indirizzo_mssp} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Città</label>
              <input type="text" name="citta_mssp" value={form.citta_mssp} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Provincia</label>
              <input
                type="text"
                name="provincia_mssp"
                value={form.provincia_mssp}
                onChange={handleChange}
                className="w-full p-2 border rounded disabled:opacity-60"
                pattern="[A-Za-z]{2}"
                minLength="2"
                maxLength="2"
                style={{ textTransform: 'uppercase' }}
                title="Inserire la sigla provincia (2 lettere, es. RM)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">CAP</label>
              <input
                type="text"
                name="cap_mssp"
                value={form.cap_mssp}
                onChange={handleChange}
                className="w-full p-2 border rounded disabled:opacity-60"
                pattern="[0-9]{5}"
                minLength="5"
                maxLength="5"
                title="Inserire un CAP valido (5 cifre)"
              />
            </div>
            <div className="col-span-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Note interne</label>
              <textarea name="note_mssp" value={form.note_mssp} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" rows={2} />
            </div>
            <div className="col-span-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
              {form.logo && <img src={form.logo} alt={isReseller ? 'Logo Reseller' : 'Logo MSSP'} className="h-16 mb-2" />}
              <input type="file" name="logo" accept="image/*" onChange={e => setForm(f => ({ ...f, logo: e.target.files[0] }))} className="w-full" />
            </div>
            {/* Messaggi di errore/successo */}
            <div className="col-span-3">
              {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
              {success && <div className="text-green-500 text-sm mb-2">Salvataggio effettuato!</div>}
            </div>
            {/* Bottoni */}
            <div className="col-span-3 flex justify-center space-x-3 mt-2">
              <button
                type="button"
                className="flex items-center gap-2 bg-yellow-500 text-white shadow-md hover:bg-yellow-600 hover:shadow-lg transition-all duration-300 px-5 py-2 rounded-md active:scale-95 disabled:opacity-50"
                onClick={onClose}
                disabled={loading}
              >
                Chiudi
              </button>
              <button
                type="submit"
                className="flex items-center gap-2 bg-yellow-500 text-white shadow-md hover:bg-yellow-600 hover:shadow-lg transition-all duration-300 px-5 py-2 rounded-md active:scale-95 disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
